import { useRecoilValue } from 'recoil';
import { activeTabState } from '../../atoms';
import ContactForm from './Contact';
import { HomeWrapper } from './HomeWrapper';
import Intro from './Intro';
import Projects from './Projects';
import Skills from './Skills';
import './styles.scss';

const Home = () => {
  const activeTab = useRecoilValue(activeTabState);

  switch (activeTab) {
    case 'home':
      return (
        <HomeWrapper>
          <Intro />
        </HomeWrapper>
      );
    case 'skills':
      return (
        <HomeWrapper>
          <Skills />
        </HomeWrapper>
      );
    case 'projects':
      return (
        <HomeWrapper>
          <Projects />
        </HomeWrapper>
      );
    case 'contact':
      return (
        <HomeWrapper>
          <ContactForm />
        </HomeWrapper>
      );
    default:
      return <></>;
  }
};

export default Home;
